const getDevicePixelRatio = () => {
  if (typeof window === 'undefined') {
    return 1;
  }
  return window.devicePixelRatio || 1;
};

module.exports = getDevicePixelRatio;



// WEBPACK FOOTER //
// ./src/common/utils/device-pixel-ratio.js